import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

function BaseSelect({ options, onChange, defaultValue, theme }) {
  const buildOption = option => (
    <option
      value={option.id}
      key={option.id}
    >
      {option.displayName}
    </option>
  );

  const sortBy = (x, y) => x.position - y.position;
  return (
    <div
      className={
        classNames(
          'c-base-select',
          theme['c-base-select'],
        )
      }
    >
      <select key={defaultValue} onChange={onChange} defaultValue={defaultValue}>
        {options.slice().sort(sortBy).map(buildOption)}
      </select>
    </div>
  );
}

BaseSelect.propTypes = {
  theme: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.func,
  ]).isRequired,
  onChange: PropTypes.func,
  defaultValue: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      displayName: PropTypes.string,
    })
  ),
};

export default BaseSelect;



// WEBPACK FOOTER //
// ./app/components/BaseSelect/index.js